import {Component} from '@angular/core';
import {Toast} from 'ngx-toastr';
import {IconCheckComponent} from '../icons/icon-check/icon-check.component';
import {IconErrorComponent} from '../icons/icon-error/icon-error.component';
import {IconCloseFillComponent} from '../icons/icon-close-fill/icon-close-fill.component';

@Component({
  selector: 'braidsbook-toastr',
  imports: [
    IconCheckComponent,
    IconErrorComponent,
    IconCloseFillComponent
  ],
  templateUrl: './toastr.component.html'
})
export class ToastrComponent extends Toast {

}
